import React, {
  useContext,
  useEffect,
  useState
} from 'react';

import { RequestNextApi } from '../../../api/Request';
import { ProgressContext } from '../../../components/Context/progressContext';
import { getCookie } from '../../../utils/cookieHandle';
import { ShowNotification } from '../../../utils/notification/snackbarUtils';
import { showArticleBlock } from '../../../utils/static-pages/function';
import { ARTICLE_BLOCKS_TYPE, PAGES_SLUG } from '../../../utils/static-pages/model';
import MemberConnections from '../../../components/ArticleBlocks/MemberConnections';
import Link from 'next/link';



export default function Home() {
  const [articleBlocks, setArticleBlocks] = useState();
  const { state: progressContext, update: updateProgress } = useContext(ProgressContext);
  const [canRenewCertification, setCanRenewCertification] = useState(null);

  const fetchCanRenewCertification = async () => {
    try {
      const result = await RequestNextApi.post('/cka/user-fetch-cka', {
        jwtToken: getCookie('jwt-token'),
      });
      if (result.data.success) {
        setCanRenewCertification(result.data.user.canRenewCertification);
      }
    } catch (e) {

    }
  }

  useEffect(() => {
    const fetchPage = async () => {
      try {
        updateProgress({ isLoading: true });
        const res = await RequestNextApi.post('/pages',
          {
            slug: PAGES_SLUG.MEMBER_HOME,
            jwtToken: getCookie('jwt-token')
          }
        );
        if (res.data.success) {
          setArticleBlocks(res.data.page.articleBlocks);
          fetchCanRenewCertification()
        } else {
          ShowNotification.error('Fetch page failed');
        }
      } catch (error) {
        ShowNotification.error('Fetch page failed');
      } finally {
        updateProgress({ isLoading: false });
      }
    };
    fetchPage();
  }, []);

  const renewBanner = React.useMemo(() => {
    return canRenewCertification &&
      <div className='font-bold mt-6 text-red-500 bg-red-100 p-4 rounded-md mx-auto max-w-7xl'>
        It is time to renew your CKA® designation. Please{" "}
        <Link href='/members/account/certification/recertification' legacyBehavior><a>click here</a></Link>
        {" "}to get started.
      </div>
  }, [canRenewCertification])

  return (
    <div>
      {articleBlocks && (
        <div>
          {articleBlocks.map((item, index) => {
            if (item.type === ARTICLE_BLOCKS_TYPE.FRONT_END_COMPONENT && item.componentName === 'memberConnections') {
              return <MemberConnections key={index} banner={renewBanner} />
            } else {
              return showArticleBlock(item, index)
            }
          })}
        </div>
      )}
    </div>
  )
}
